import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-validate-account',
  templateUrl: './user-validate-account.component.html',
  styleUrls: ['./user-validate-account.component.css']
})
export class UserValidateAccountComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
